import { inject, NgZone, Service } from '@angular/core';

/** Internal class around window object for use within Angular context. */
@Service()
export class _BaasWindow {
    readonly #ngZone = inject(NgZone);
    /** Sets a timeout on the window object outside angular to avoid change detection cycles because of zonejs. */
    setTimeoutOutsideAngular(handler: TimerHandler, timeout?: number): Promise<number> {
        return new Promise<number>((resolve) => {
            this.#ngZone.runOutsideAngular(() => {
                const result = window.setTimeout(handler, timeout);
                resolve(result);
            });
        });
    }

    setIntervalOutsideAngular(handler: TimerHandler, timeout?: number): Promise<number> {
        return new Promise<number>((resolve) => {
            this.#ngZone.runOutsideAngular(() => {
                const result = window.setInterval(handler, timeout);
                resolve(result);
            });
        });
    }
}
